import React, { Fragment, useEffect, useState } from "react";
import ReactPaginate from "react-paginate";

function Items({ currentItems }) {
  return (
    <>
      {currentItems}
    </>
  );
}

function PaginatedItems({ gridKeys, searchObjInit, searchObject, originalGrid, setGrid, dataCount, pageLimit, setPage, setPageLimit, requestSort, sortConfig, updateSearchData, page, grid, data }) {


  // Invoke when user click to request another page.
  const handlePageClick = async (event) => {
    const currentPage = event.selected;
    console.log(currentPage);
    setPage(currentPage);   
  };

  useEffect(() => {
    searchForSpecificKey();
    }, [searchObject])

  function trimString(s) {  
    var l=0, r=s.length -1;
    while(l < s.length && s[l] == ' ') l++;
    while(r > l && s[r] == ' ') r-=1;
    return s.substring(l, r+1);
  }
  
  function compareObjects(o1, o2) {
    var k = '';
    for(k in o1) if(o1[k] != o2[k]) return false;
    for(k in o2) if(o1[k] != o2[k]) return false;
    return true;
  }
  
  function itemExists(haystack, needle) {
    for(var i=0; i<haystack.length; i++) if(compareObjects(haystack[i], needle)) return true;
    return false;
  }

  
  function searchForSpecificKey() {
    var results = [];
    if(JSON.stringify(searchObject) !== JSON.stringify(searchObjInit)) {
        setPage(0);
        for(var i=0; i < originalGrid.length; i++) {
            for(var key in searchObject) {
                var kval = originalGrid[i][key] != null ? String(originalGrid[i][key]) : null;
                if(searchObject[key] != '') {
                    if(kval != null && kval.toLowerCase().indexOf(searchObject[key].toLowerCase()) != -1) {
                        if(!itemExists(results, originalGrid[i])) results.push(originalGrid[i]);
                    }
                }
            }
        }
        setGrid(results);
    } else {
        setGrid(originalGrid);
    }
  } 


  return (
    <>
        <div className="table-responsive">
                                    <table className="table table-bordered">
                                            <thead>
                                                <tr key={'th2'}>
                                                    <th key={'th1'}>S.No</th>
                                                    {
                                                      gridKeys.map((e,i) => 
                                                        e.visible ?  
                                                        <th 
                                                            className={e.key === '' ? "th-datatable" : "th-datatable cursor-pointer"}
                                                            onClick={() => {
                                                                requestSort(e.key === '' ? 'NoArrow' : e.key)
                                                            }}
                                                            title="Sort"
                                                            key={i}
                                                        >{e.name} 
                                                          <i 
                                                          key={i}
                                                              className={
                                                              sortConfig.key === e.key
                                                                  ? sortConfig.direction === 'ascending'
                                                                      ? 'icon-setting fa fa-arrow-down'
                                                                      : 'icon-setting fa fa-arrow-up'
                                                                  : ''
                                                              } aria-hidden="true"></i>

                                                        </th>: <></>)
                                                    }


                                                    {/* <th 
                                                        className="th-datatable cursor-pointer"
                                                        onClick={() => requestSort('cn')}
                                                        title="Sort"
                                                    >CN 
                                                        <i className={
                                                            sortConfig.key === 'cn'
                                                                ? sortConfig.direction === 'ascending'
                                                                    ? 'icon-setting fa fa-arrow-down'
                                                                    : 'icon-setting fa fa-arrow-up'
                                                                : ''
                                                            } aria-hidden="true"></i>

                                                    </th>
                                                    <th 
                                                        className="th-datatable cursor-pointer"
                                                        onClick={() => requestSort('consignerAccountNo')}
                                                    >Account#
                                                    
                                                        <i className={
                                                                sortConfig.key === 'consignerAccountNo'
                                                                    ? sortConfig.direction === 'ascending'
                                                                        ? 'icon-setting fa fa-arrow-down'
                                                                        : 'icon-setting fa fa-arrow-up'
                                                                    : ''
                                                                } aria-hidden="true"></i>

                                                    </th>
                                                    <th
                                                        className="th-datatable cursor-pointer"
                                                        onClick={() => requestSort('locationName')}>Location Name
                                                        <i className={
                                                                sortConfig.key === 'locationName'
                                                                    ? sortConfig.direction === 'ascending'
                                                                        ? 'icon-setting fa fa-arrow-down'
                                                                        : 'icon-setting fa fa-arrow-up'
                                                                    : ''
                                                                } aria-hidden="true"></i>
                                                    </th>
                                                    <th 
                                                        className="th-datatable cursor-pointer"
                                                        onClick={() => requestSort('bookingDate')}>Booking Date
                                                    <i className={
                                                                sortConfig.key === 'bookingDate'
                                                                    ? sortConfig.direction === 'ascending'
                                                                        ? 'icon-setting fa fa-arrow-down'
                                                                        : 'icon-setting fa fa-arrow-up'
                                                                    : ''
                                                                } aria-hidden="true"></i>
                                                    </th>
                                                    {data.status == 3 && <th>Arrival Date</th>}
                                                    <th className="th-datatable cursor-pointer" onClick={() => requestSort('refNo')}>Ref No
                                                    <i className={
                                                                sortConfig.key === 'refNo'
                                                                    ? sortConfig.direction === 'ascending'
                                                                        ? 'icon-setting fa fa-arrow-down'
                                                                        : 'icon-setting fa fa-arrow-up'
                                                                    : ''
                                                                } aria-hidden="true"></i>
                                                    </th>
                                                    <th className="th-datatable cursor-pointer" onClick={() => requestSort('consignee')}>Consignee
                                                    <i className={
                                                                sortConfig.key === 'consignee'
                                                                    ? sortConfig.direction === 'ascending'
                                                                        ? 'icon-setting fa fa-arrow-down'
                                                                        : 'icon-setting fa fa-arrow-up'
                                                                    : ''
                                                                } aria-hidden="true"></i>
                                                    </th>
                                                    <th className="th-datatable cursor-pointer" onClick={() => requestSort('consigneeAddress')}>Consignee Address
                                                    <i className={
                                                                sortConfig.key === 'consigneeAddress'
                                                                    ? sortConfig.direction === 'ascending'
                                                                        ? 'icon-setting fa fa-arrow-down'
                                                                        : 'icon-setting fa fa-arrow-up'
                                                                    : ''
                                                                } aria-hidden="true"></i>
                                                    </th>
                                                    <th className="th-datatable cursor-pointer" onClick={() => requestSort('consigneePhoneNo')}>Consignee PhoneNo
                                                    <i className={
                                                                sortConfig.key === 'consigneePhoneNo'
                                                                    ? sortConfig.direction === 'ascending'
                                                                        ? 'icon-setting fa fa-arrow-down'
                                                                        : 'icon-setting fa fa-arrow-up'
                                                                    : ''
                                                                } aria-hidden="true"></i>
                                                    </th>
                                                    <th className="th-datatable cursor-pointer" onClick={() => requestSort('consigneeEmail')}>Consignee Email
                                                    <i className={
                                                                sortConfig.key === 'consigneeEmail'
                                                                    ? sortConfig.direction === 'ascending'
                                                                        ? 'icon-setting fa fa-arrow-down'
                                                                        : 'icon-setting fa fa-arrow-up'
                                                                    : ''
                                                                } aria-hidden="true"></i>
                                                    </th>
                                                    <th className="th-datatable cursor-pointer" onClick={() => requestSort('codAmount')}>Cod Amount
                                                    <i className={
                                                                sortConfig.key === 'codAmount'
                                                                    ? sortConfig.direction === 'ascending'
                                                                        ? 'icon-setting fa fa-arrow-down'
                                                                        : 'icon-setting fa fa-arrow-up'
                                                                    : ''
                                                                } aria-hidden="true"></i>
                                                    </th>
                                                    <th className="th-datatable cursor-pointer" onClick={() => requestSort('productDescription')}>Product Description
                                                    <i className={
                                                                sortConfig.key === 'productDescription'
                                                                    ? sortConfig.direction === 'ascending'
                                                                        ? 'icon-setting fa fa-arrow-down'
                                                                        : 'icon-setting fa fa-arrow-up'
                                                                    : ''
                                                                } aria-hidden="true"></i>
                                                    </th>
                                                    <th className="th-datatable cursor-pointer" onClick={() => requestSort('weight')}>Weight
                                                    <i className={
                                                                sortConfig.key === 'weight'
                                                                    ? sortConfig.direction === 'ascending'
                                                                        ? 'icon-setting fa fa-arrow-down'
                                                                        : 'icon-setting fa fa-arrow-up'
                                                                    : ''
                                                                } aria-hidden="true"></i>
                                                    </th>
                                                    <th className="th-datatable cursor-pointer" onClick={() => requestSort('origin')}>Origin
                                                    <i className={
                                                                sortConfig.key === 'origin'
                                                                    ? sortConfig.direction === 'ascending'
                                                                        ? 'icon-setting fa fa-arrow-down'
                                                                        : 'icon-setting fa fa-arrow-up'
                                                                    : ''
                                                                } aria-hidden="true"></i>
                                                    </th>
                                                    <th className="th-datatable cursor-pointer" onClick={() => requestSort('destination')}>Destination
                                                    <i className={
                                                                sortConfig.key === 'destination'
                                                                    ? sortConfig.direction === 'ascending'
                                                                        ? 'icon-setting fa fa-arrow-down'
                                                                        : 'icon-setting fa fa-arrow-up'
                                                                    : ''
                                                                } aria-hidden="true"></i>
                                                    </th>
                                                    <th className="th-datatable cursor-pointer" onClick={() => requestSort('remarks')}>Remarks
                                                    <i className={
                                                                sortConfig.key === 'remarks'
                                                                    ? sortConfig.direction === 'ascending'
                                                                        ? 'icon-setting fa fa-arrow-down'
                                                                        : 'icon-setting fa fa-arrow-up'
                                                                    : ''
                                                                } aria-hidden="true"></i>
                                                    </th> */}


                                                </tr>

                                                
                                            </thead>
                                            <tbody>
                                                        {
                                                            gridKeys.filter(w => w.searchBox == true).length > 0 && 
                                                            <tr key={'start2'}>
                                                                <td key={'he2'}></td>
                                                                {gridKeys.map((g, i) => {

                                                                return g.visible ?  
                                                                    g.searchBox ? 
                                                                        <td key={i}>
                                                                            <input type="text"  onChange={(e) => {
                                                                                updateSearchData(g.key, trimString(e.target.value));
                                                                            }}  className="inp" placeholder={g.name} />
                                                                        </td> : 
                                                                        <td key={i}></td>
                                                                    : <></>
                                                                })}
                                                            </tr>
                                                        }             
                                                        

                                                {
                                                   grid
                                                }
                                            </tbody>
                                    </table>
                                </div>
      <br />

      <div style={{display: "flex"}} className="justify-content-center">


        <div>
          {dataCount && dataCount > 0 &&  <select type="date" className="form-select" style={{color: '#e25a0c'}} onChange={(e) => { if(e.target.value != 0) {
                                    setPage(0);
                                    setPageLimit(e.target.value);
                                }}}>
                                    <option value={0}>Page Limit</option>
                                    <option value={20}>20</option>
                                    <option value={50}>50</option>
                                    <option value={100}>100</option>
                                    <option value={200}>200</option>
                                    <option value={500}>500</option>
                                    <option value={1000}>1000</option>
                                </select>}
        </div>

        {dataCount && dataCount > 0 &&
        <><ReactPaginate
                breakLabel="..."
                nextLabel="Next >"
                onPageChange={handlePageClick}
                pageRangeDisplayed={5}
                pageCount={Math.ceil(dataCount / pageLimit)}
                previousLabel="< Previous"
                renderOnZeroPageCount={null}
                marginPagesDisplayed={3}
                containerClassName={"pagination justify-content-center"}
                pageClassName={"page-item"}
                pageLinkClassName={"page-link"}
                previousClassName={"page-item"}
                previousLinkClassName={"page-link"}
                nextClassName={"page-item"}
                nextLinkClassName={"page-link"}
                breakClassName={"page-item"}
                breakLinkClassName={"page-link"}
                activeClassName="active"
            />

            <div style={{ margin:'10px'}}>
                <span style={{color: '#e25a0c', margin:'5px', fontWeight: 'bold'}}>{page * pageLimit + 1} </span> - <span style={{color: '#e25a0c', margin:'5px', fontWeight: 'bold'}}>{Math.ceil(dataCount / pageLimit) === page + 1 ? dataCount : (1+page) * pageLimit}</span>
                Of <span style={{color: '#e25a0c', margin:'5px', fontWeight: 'bold'}}>{dataCount}</span> Records
            </div> </>  }
      </div>
    </>
  );
}

export default PaginatedItems;
